import React from "react";
import { AppShell as LegacyAppShell } from "../shell/AppShell.jsx";
import { PlatformProvider } from "./PlatformContext.jsx";

export function AppShell(props) {
  const {
    appHeader,
    localNav,
    appSwitcher,
    beforeContent,
    afterContent,
    platformSlots,
    children,
    ...legacyProps
  } = props || {};

  const resolvedAppHeader = appHeader ?? platformSlots?.appHeader ?? null;
  const resolvedLocalNav = localNav ?? platformSlots?.localNav ?? null;
  const resolvedAppSwitcher = appSwitcher ?? platformSlots?.appSwitcher ?? null;
  const resolvedBeforeContent = beforeContent ?? platformSlots?.beforeContent ?? null;
  const resolvedAfterContent = afterContent ?? platformSlots?.afterContent ?? null;

  const hasAnySlot =
    resolvedAppHeader != null ||
    resolvedLocalNav != null ||
    resolvedAppSwitcher != null ||
    resolvedBeforeContent != null ||
    resolvedAfterContent != null;

  if (!hasAnySlot) {
    return (
      <PlatformProvider>
        <LegacyAppShell {...legacyProps}>{children}</LegacyAppShell>
      </PlatformProvider>
    );
  }

  const slottedContent = (
    <>
      {resolvedAppSwitcher}
      {resolvedAppHeader}
      {resolvedLocalNav}
      {resolvedBeforeContent}
      {children}
      {resolvedAfterContent}
    </>
  );

  return (
    <PlatformProvider>
      <LegacyAppShell {...legacyProps}>{slottedContent}</LegacyAppShell>
    </PlatformProvider>
  );
}

